import { FaUser  } from "react-icons/fa";
const SoftwareEngineerSectionComponent = () => {

  const textMute = () => {
    return "text-muted";
  };
  
  return(
    <div className=" mt-3">
      <FaUser size={28} className={textMute()}/>
      <h4 className={textMute()} style={{display: "inline"}}>&nbsp;SOFTWARE ENGINEER</h4>
      <hr />
      <ol>
        <li><p>Problem solver, fast learner and hard working to write well-designed, testable and efficient code using best practices in Web development.</p></li>
        <li><p>Skilled team player able to strive to design and collaborate on complex projects - from concept, navigation, layout and programming to SEO.</p></li>
      </ol>
    </div>
  ); 
};
export default SoftwareEngineerSectionComponent;